export default {
    READY: 'READY',
    NO_RESULTS: 'NO_RESULTS',
    PENDING: 'PENDING',
    INSTANT: 'INSTANT',
    FAILED: 'FAILED'
};
